export enum EnumPaymentGeneralStatus {
  Pending = 0,
  Cancelled = 1,
  Completed = 2,
  InProgress = 3,
  Refunded = 4
}
